module.exports = __webpack_public_path__ + "static/img/male-4.a9bcf014.webp";